import { dataMenu } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMenu = /*#__PURE__*/createIcon(dataMenu)
export default IconMenu
